module.exports = __webpack_public_path__ + "img/jin7.8f8d597e.png";